import React, {useEffect} from 'react'
import {Modal, Form, Row, Col, Input, Collapse, Button, Select} from 'antd'
import Editor from '../../../utils/brace'
import {withTranslation} from 'react-i18next'

const {Panel} = Collapse
const GroovyModal = (props) => {
  const {verVisible, handleCancel, ref, state, t} = props
  const [form] = Form.useForm()

  const formItemLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
  }
  useEffect(() => {
    setGroovyDetail()
  })
  const setGroovyDetail = () => {
    form.setFieldsValue({
      client: state.groovyClient ? state.groovyClient : null,
      name: state.groovyName ? state.groovyName : null,
    })
  }
  return (
    <>
      <Modal
        title={t(`mappingManagement.groovy`)}
        closable={true}
        visible={verVisible}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose={true}
        width={1000}
        centered
        footer={[
          <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>
        ]}
      >

        <Form form={form} name="basic" autoComplete="off"
        >
          <Row wrap={true} gutter={[10, 20]}>
            <Col span={12}>
              <Form.Item label={t(`mappingManagement.name`)} name="name" {...formItemLayout}>
                <Input disabled/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item style={{margin: 0,}} name="client" label={t(`mappingManagement.module`)} {...formItemLayout}>
                <Select
                  placeholder={t(`general.pleaseSelect`)}
                  disabled
                >
                  <Select.Option key="DataSource" value="DATASOURCE">{t(`mappingManagement.dataSource`)}</Select.Option>
                  <Select.Option key="DataTarget" value="DATATARGET">{t(`mappingManagement.dataTarget`)}</Select.Option>
                  <Select.Option key="InBoundAPI" value="INBOUNDAPI">{t(`mappingManagement.inboundApi`)}</Select.Option>
                  <Select.Option key="OutBoundAPI" value="OUTBOUNDAPI">{t(`mappingManagement.outboundApi`)}</Select.Option>
                  <Select.Option key="Mapping" value="MAPPING">{t(`mappingManagement.mapping`)}</Select.Option>
                  <Select.Option key="Mappingpre" value="MAPPINGPRE">{t(`mappingManagement.mappingPre`)}</Select.Option>
                  <Select.Option key="Mappingpost" value="MAPPINGPOST">{t(`mappingManagement.mappingPost`)}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Collapse defaultActiveKey={['1', '2', '3']}>
                <Panel header={t(`mappingManagement.script`)} key="1">
                  {
                    <Editor
                      ref={ref}
                      mode="json"
                      width="100%"
                      height="300px"
                      theme="chrome"
                      enableBasicAutocompletion={false}
                      enableLiveAutocompletion={false}
                      enableSnippets={false}
                      enableEmmet={false}
                      useElasticTabstops={false}
                      setOptions={{useWorker: false}}
                      fontSize="16px"
                      value={state.groovyScript ? state.groovyScript : null}
                      readOnly={true}
                    ></Editor>
                  }
                </Panel>
              </Collapse>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

export default withTranslation()(GroovyModal)
